import './../css/app.pcss';

import { createApp } from 'vue';
import VueGoogleMaps from '@fawmi/vue-google-maps';

// Commons
import header from '/src/ts/commons/header.ts';
import footer from '/src/ts/commons/footer.ts';
import csrf from '/src/ts/commons/csrf.ts';

// Vue Stores
import StockistsStore from '/src/vue/stores/stockists.ts';
import CustomerStore from '/src/vue/stores/customer.ts';

// Components
import StockistMap from '/src/vue/components/StockistMap.ts';
import StockistList from '/src/vue/components/StockistList.ts';
import StockistSearch from '/src/vue/components/StockistSearch.ts';
import StockistRadius from '/src/vue/components/StockistRadius.ts';
import StockistAccordion from '/src/vue/components/StockistAccordion.ts';

export default function init() {
  csrf();
  // Header Vue Instance
  header(CustomerStore());
  // Get api key
  const rootEl = document.getElementById('locate-a-stockist');
  if (!rootEl) {
    return false;
  }

  const { key } = rootEl.dataset;

  // Create the vue instance
  const vueInstance = createApp({
    components: {
      StockistList,
      StockistMap,
      StockistAccordion,
      StockistSearch,
      StockistRadius,
    },
    data() {
      return {
        googleMap: null,
        isGoogleAvailable: false,
      };
    },
    mounted() {
      this.$store.dispatch('getStockists');
    },
    methods: {
      setGoogleMap(value: any) {
        this.googleMap = value;
      },
      setIsGoogleAvailable(status: boolean) {
        this.isGoogleAvailable = status;
      },
    }
  });
  vueInstance
    .use(VueGoogleMaps, {
      load: {
        key,
        libraries: 'geometry',
      },
    })
    .use(StockistsStore());
  vueInstance.mount('#locate-a-stockist');
  // Footer Vue Instance
  footer();
}
init();
